module.exports = __webpack_public_path__ + "staticcomp/img/aboutme_top_img.2b9aebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutme_top_img.jpg
// module id = S5tg
// module chunks = 39